<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <!-- <router-view/> -->
    <router-view></router-view>
  </div>
</template>
<script>

</script>
<script>
export default {
  name: 'App',
  components:{

  },
  data() {
      return {

      }
  },
  methods:{

  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
}
  *{
    margin: 0;
  }
  body{
    margin: 0;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue